import { useEffect, useState } from "react";
import { PageHeader, useTitle } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { api, asset } from "@/lib/api";
import { useSiteConfig } from "@/context/SiteConfig";

// Reusable card grid for editable "group" collections (tribes, gangs).
const GROUP_SEO = {
  tribes: "Discover the tribes of Aurora Springs RP and their place in our 1895 RedM Wild West roleplay world.",
  gangs: "Outlaw gangs and organizations in Aurora Springs RP — criminal factions and territory on our 1895 RedM roleplay server.",
};

export default function GroupPage({ path, sectionKey, defaultImage, title, overline, sub, emptyText }) {
  useTitle(`${title} | Aurora Springs RP | RedM Roleplay`, GROUP_SEO[sectionKey]);
  const { img } = useSiteConfig();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/${path}`).then(({ data }) => setItems(data || [])).catch(() => {}); }, [path]);

  return (
    <>
      <PageHeader overline={overline} title={title} image={img(sectionKey, defaultImage)} sub={sub} />
      <section className="mx-auto max-w-7xl px-6 sm:px-10 py-20">
        {items.length === 0 ? (
          <div className="border border-dashed border-[#2A201A] py-24 text-center text-[#8F877C]">{emptyText}</div>
        ) : (
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {items.map((it, i) => (
              <Reveal key={it.id || i} delay={(i % 3) * 0.06}>
                <div data-testid={`${path}-card-${i}`} className="group relative overflow-hidden border border-[#2A201A] bg-surface/40 h-full hover:border-teal/40 transition-colors">
                  <div className="relative h-64 overflow-hidden">
                    {it.image ? (
                      <img src={asset(it.image)} alt={it.name} className="h-full w-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700" />
                    ) : <div className="h-full w-full bg-surface" />}
                    <div className="absolute inset-0 bg-gradient-to-t from-surface to-transparent" />
                    {it.tag && <span className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-widest text-teal border border-teal/30 bg-obsidian/60 px-2 py-1">{it.tag}</span>}
                  </div>
                  <div className="p-7">
                    <h3 className="font-display text-3xl font-light">{it.name}</h3>
                    {it.description && <p className="mt-3 text-sm text-[#8F877C] leading-relaxed">{it.description}</p>}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </>
  );
}
